import { jsx } from 'react/jsx-runtime';
import BasePreferredPaymentBox from '../BasePreferredPaymentBox/BasePreferredPaymentBox.js';
import img from '../../../../assets/payconiq_logo.png.js';
import { useTranslation } from '../../../../hooks/useTranslations.js';
import { getIBANLastFourDigits } from '../../../../utils/cardUtils.js';

const pm_text = {
    KL: 'general.payment.KL.name',
    KO: 'general.payment.KO.name',
    R: 'general.payment.invoice',
    CD: 'general.payment.cashondelivery',
    VK: 'payment.prepaired.description',
};
const PreferredPaymentSwitch = ({ preferredPayment }) => {
    const { t } = useTranslation();
    const { paymentMethodShortName: paymentMethod, details } = preferredPayment;
    const issuerInfo = details?.lastIssuer;
    const sepaData = details?.bankAccountDetails;
    const creditCard = details?.cards?.[0];
    const creditCardInfo = creditCard || undefined;
    switch (paymentMethod) {
        case 'ID':
        case 'OP':
            return (jsx(BasePreferredPaymentBox, { logo: paymentMethod, cobrandLogo: issuerInfo?.logoUrl || undefined, paymentOption: issuerInfo?.issuerName || undefined }));
        case 'BM':
            return (jsx(BasePreferredPaymentBox, { logo: paymentMethod, cobrandLogo: img, paymentOption: "Bancontact by Payconiq" }));
        case 'BC':
            return (jsx(BasePreferredPaymentBox, { logo: paymentMethod, cobrandLogo: img, creditCardData: creditCardInfo }));
        case 'K':
            return jsx(BasePreferredPaymentBox, { creditCardData: creditCardInfo });
        case 'CD': //cash on delivery
        case 'R': //invoice
        case 'VK': //prepayment, bank transfer
            return jsx(BasePreferredPaymentBox, { logo: paymentMethod, text: t(pm_text[paymentMethod]) });
        case 'KL': //klarna pay later
        case 'KO': //klarna pay over time
            return (jsx(BasePreferredPaymentBox, { logo: paymentMethod, paymentOption: t(pm_text[paymentMethod]) }));
        case 'BS': //SEPA
            return (jsx(BasePreferredPaymentBox, { logo: paymentMethod, text: `${t('general.payment.direct_debit_sepa_info')} ${getIBANLastFourDigits(sepaData?.number)}`, subText: sepaData?.owner || undefined }));
        case 'PP': //Paypal
        case 'AP': //ApplePay
        case 'TY': //Trustly
        case 'TW': //TWINT
        case 'MB': //MultiBanco
        case 'PT': //Paytrail
        case 'DP': //DotPay
            return jsx(BasePreferredPaymentBox, { logo: paymentMethod });
    }
    return null;
};

export { PreferredPaymentSwitch as default };
//# sourceMappingURL=PreferredPaymentSwitch.js.map
